export default "__VITE_ASSET__Bgyku8hL__"